import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import SendIcon from "@mui/icons-material/Send";
import CrossButton from "../cross-button";

import useIsImageHorizontal from "../../hooks/useIsImageHorizontal";
import StyledSendImageModal from "./styles";

const SendImageModal = ({ open, onCloseButton, image, onSend, onClose }) => {
  const isHorizontal = useIsImageHorizontal(image);

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <StyledSendImageModal>
          <div className="send-image-modal">
            <div className="img-container">
              <div
                className={`image-reference ${
                  isHorizontal
                    ? "image-reference--horizontal"
                    : "image-reference--vertical"
                }`}
              >
                <img
                  className="image-container"
                  src={image}
                  alt={`selected-${Math.random()}`}
                />
              </div>
            </div>
            <div className="actions">
              <div />
              <div className="send-icon-cont">
                <SendIcon
                  onClick={onSend}
                  className="action-icon send-icon"
                  sx={{ fill: "white" }}
                />
              </div>
            </div>
            <CrossButton className="cross-button" onClick={onCloseButton} />
          </div>
        </StyledSendImageModal>
      </Fade>
    </Modal>
  );
};

export default SendImageModal;
